module.exports = __webpack_public_path__ + "img/word.1ecd4932.png";